import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ValetWithholding} from '../../../models/valet-withholding';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'pv-common-valet-withholding-dialog',
  templateUrl: './common-valet-withholding-dialog.component.html',
  styleUrls: ['./common-valet-withholding-dialog.component.scss']
})
export class CommonValetWithholdingDialogComponent implements OnInit {

  @Input() withholding: ValetWithholding | null;
  @Output() submitEvent = new EventEmitter<ValetWithholding | void>();

  public form: FormGroup;

  constructor(protected dialogRef: NbDialogRef<CommonValetWithholdingDialogComponent>,
              private fb: FormBuilder) { }

  ngOnInit(): void {
    const amountValidators = [Validators.required, Validators.min(0), Validators.max(100000)];
    const installmentsValidators = [Validators.required, Validators.min(0), Validators.max(100)];
    this.form = this.fb.group({
      name: [null, [Validators.required]],
      totalAmount: [null, amountValidators],
      totalInstallments: [1, installmentsValidators],
      allowInExpenses: [false]
    });
    if (this.withholding) {
      this.form.addControl('remainingAmount', new FormControl(null, amountValidators));
      this.form.addControl('remainingInstallments', new FormControl(null, installmentsValidators));
      this.form.removeControl('allowInExpenses');
      this.form.patchValue(this.withholding);
    }
  }

  cancel() {
    this.submitEvent.emit();
  }

  submit() {
    this.submitEvent.emit(this.form.getRawValue());
  }

}
